import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { IconButton, Tooltip } from "@material-ui/core";
import ContactSupportOutlinedIcon from "@material-ui/icons/ContactSupportOutlined";

import { i18n } from "../../translate/i18n";
import useSupportAccess from "../../hooks/useSupportAccess";
import { AuthContext } from "../../context/Auth/AuthContext";
import { loadDraft, saveDraft } from "../../pages/Support/supportDraft";

// feat_404 — botón "Soporte" de la cabecera del chat. Copia el ID del ticket,
// precarga el borrador (ticket, contacto, conexión) y abre /soporte. El texto
// queda vacío: lo escribe el usuario. Si ya tenía un borrador, lo conserva.
const copyText = async text => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (__) {
      return false;
    }
  }
};

const SupportButton = ({ ticket }) => {
  const allowed = useSupportAccess();
  const history = useHistory();
  const { user } = React.useContext(AuthContext);
  if (!allowed || !ticket?.id) return null;

  const handleClick = async () => {
    const ok = await copyText(String(ticket.id));
    if (ok) toast.info(i18n.t("support.idCopied"));
    else toast.warn(i18n.t("support.idCopyFailed"));
    const prev = loadDraft(user);
    saveDraft(user, {
      text: prev.ticket?.id === ticket.id ? prev.text : "",
      ticket: {
        id: ticket.id,
        contactId: ticket.contactId || ticket.contact?.id || null,
        contactName: ticket.contact?.name || ticket.contact?.whatsappName || "",
        whatsappName: ticket.whatsapp?.name || "",
      },
      whatsappId: ticket.whatsappId ? String(ticket.whatsappId) : "",
      images: prev.images,
    });
    history.push("/soporte", { focus: true });
  };

  return (
    <Tooltip title={i18n.t("support.buttonTooltip")} arrow>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-label={i18n.t("support.buttonLabel")}
        style={{ color: "#128C7E" }}
      >
        <ContactSupportOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default SupportButton;
